<section id="ai-features" class="ai-features-section">
  <div class="container">
    <h2 class="section-title" data-animation="fade-in-up" data-animation-delay="1">AI-Powered Features</h2>
    <p class="text-center mb-5" data-animation="fade-in-up" data-animation-delay="2">
      The next generation of Relay brings cutting-edge artificial intelligence to revolutionize your testing workflows.
    </p>

    <!-- Horizontal scrolling slider for AI features -->
    <div class="ai-features-slider" data-animation="fade-in-up" data-animation-delay="1">
      <div class="slider-container">
        <div class="slider-track" #sliderTrack>
          <!-- AI Features -->
          <div class="ai-feature-slide" *ngFor="let feature of aiFeatures; let i = index">
            <div class="ai-feature-card"
                 [ngClass]="{'active': feature.isActive, 'completed': feature.status === 'completed', 'in-progress': feature.status === 'in-progress'}"
                 (click)="toggleFeature(feature)">
              <div class="status-indicator">
                <span *ngIf="feature.status === 'completed'" class="badge-completed">
                  <i class="fas fa-check-circle"></i> Completed
                </span>
                <span *ngIf="feature.status === 'in-progress'" class="badge-in-progress">
                  <i class="fas fa-spinner fa-spin"></i> In Progress
                </span>
              </div>
              <h4>{{feature.title}}</h4>
              <p>{{feature.description}}</p>
            </div>
          </div>

          <!-- Duplicate for continuous scrolling effect -->
          <div class="ai-feature-slide duplicate-card" *ngFor="let feature of aiFeatures; let i = index">
            <div class="ai-feature-card"
                 [ngClass]="{'active': feature.isActive, 'completed': feature.status === 'completed', 'in-progress': feature.status === 'in-progress'}"
                 (click)="toggleFeature(feature)">
              <div class="status-indicator">
                <span *ngIf="feature.status === 'completed'" class="badge-completed">
                  <i class="fas fa-check-circle"></i> Completed
                </span>
                <span *ngIf="feature.status === 'in-progress'" class="badge-in-progress">
                  <i class="fas fa-spinner fa-spin"></i> In Progress
                </span>
              </div>
              <h4>{{feature.title}}</h4>
              <p>{{feature.description}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Prompt Based Web Automation Modal -->
  <app-prompt-automation-modal
    [isVisible]="showPromptAutomationModal"
    (closeModalEvent)="closePromptAutomationModal()">
  </app-prompt-automation-modal>

  <!-- Intelligent Image Comparison Modal -->
  <app-image-comparison-modal
    [isVisible]="showImageComparisonModal"
    (closeModalEvent)="closeImageComparisonModal()">
  </app-image-comparison-modal>

  <!-- Intelligent Test Results Summary Modal -->
  <app-intelligent-summary-modal
    [isVisible]="showTestResultsSummaryModal"
    (closeModal)="closeTestResultsSummaryModal()">
  </app-intelligent-summary-modal>

  <!-- Test Case Validation Modal -->
  <app-test-case-validation-modal
    [isVisible]="showTestCaseValidationModal"
    (closeModal)="closeTestCaseValidationModal()">
  </app-test-case-validation-modal>

  <!-- Test Data Recommendation Modal -->
  <app-test-data-recommendation-modal
    [isVisible]="showTestDataRecommendationModal"
    (closeModal)="closeTestDataRecommendationModal()">
  </app-test-data-recommendation-modal>
</section>
